import React from "react";
import { Button } from "antd";
import WeaDialog from "../../wea-dialog";
import WeaSelectedRight from "./WeaSelectedRight";
import WeaLocaleProvider from "../../wea-locale-provider";
import { render } from "less";

const { getLabel } = WeaLocaleProvider;

class SelectedDialog extends React.PureComponent {
  static defaultProps = {
    checkedKeys: [],
    data: [],
    contentHeight: 460,
    dialogProps: {}
  };
  render() {
    const {
      checkedKeys,
      data,
      contentHeight,
      onDoubleClick,
      onVisibleChange,
      onOk,
      dialogProps
    } = this.props;
    return (
      <WeaDialog
        className="wea-browser-test-selected-dialog"
        title="已选列表"
        destroyBodyOnClose
        style={{ height: contentHeight }}
        buttons={[
          <Button
            onClick={() => {
              onVisibleChange && onVisibleChange(false);
              onOk && onOk();
            }}
            type="primary"
          >
            {getLabel(385565, "确 定")}({data.length})
          </Button>,
          <Button
            onClick={() => {
              onDoubleClick && onDoubleClick(checkedKeys);
            }}
            disabled={checkedKeys.length === 0}
          >
            {getLabel(385566, "清 除")}({checkedKeys.length})
          </Button>
        ]}
        onCancel={onVisibleChange && (() => onVisibleChange(false))}
        {...(dialogProps || {})}
      >
        <WeaSelectedRight
          {...this.props}
          forceShowAll
          height={contentHeight - 48}
          needLoading
        />
      </WeaDialog>
    );
  }
}

export default SelectedDialog;



// WEBPACK FOOTER //
// ./ecology9/wea-browser-test/components/SelectedDialog.js